const PRODUCT_TEMPLATE_PHASES = [
  { _id: 'pt-phase-field-service', name: 'Field Service' },
  { _id: 'pt-phase-inspection', name: 'Inspection' },
  { _id: 'pt-phase-repair-reassembly', name: 'Repair & Reassembly' },
  { _id: 'pt-phase-rework', name: 'Rework' },
  { _id: 'pt-phase-warranty', name: 'Warranty' },
  { _id: 'pt-phase-rotor-storage', name: 'Rotor Storage' },
  {
    _id: 'pt-phase-modifications-upgrades',
    name: 'Modifications & Upgrades',
  },
];

export default PRODUCT_TEMPLATE_PHASES;
